export enum SyncOrSwimFeatureFlags {
    EnableDisplayCustomFieldsNova = 'ENABLE_DISPLAY_CUSTOM_FIELDS_NOVA',
    EnableCredentialingCandidatesPreStartMiddleName = 'enable-credentialing-candidates-pre-start-middle-name',
    EnableCredentialingCandidatesWorkingListMiddleName = 'enable-credentialing-candidates-working-list-middle-name',
    EnableIntegrationManageV2AddVersions = 'enable-integration-manage-v2-add-versions_nova',
    EnableDisplayCustomFieldsNovaCandidates = 'ENABLE_DISPLAY_CUSTOM_FIELDS_NOVA_CANDIDATES',
    EnableAccountManagersCandidatesCustomFieldsExportNova = 'ENABLE_ACCOUNT_MANAGERS_CANDIDATES_CUSTOM_FIELDS_EXPORT_NOVA',
    EnableClientAndTypeMultiSelectDashboardFilter = 'enable-client-and-type-multiselect-dashboard-filter'
}
